// extracted by mini-css-extract-plugin
module.exports = {"page":"top-page_page__1leAZ","component":"top-page_component__RqDTA"};